<template>
  <b-dropdown class="dropdown-form" ref="dropdown" v-on:hide="sqftHidden"
              v-bind:class="{'color-button': (getMinSqft) || (getMaxSqft)}">
    <template slot="button-content">
      <i class="fas fa-ruler-combined"></i> <span v-if="!getMinSqft && !getMaxSqft">Sqft</span>
      <span v-if="getMinSqft && !getMaxSqft">{{ getMinSqft }}+</span>
      <span v-if="getMaxSqft && !getMinSqft">Up to {{ getMaxSqft }}</span>
      <span v-if="getMaxSqft && getMinSqft">{{ getMinSqft }} - {{ getMaxSqft }}</span>
    </template>
    <b-dropdown-form>
      <div class="container-fluid">
        <div class="row dropdown-row">
          <div class="col right-dropdown-col">
            <input class="form-control sqft-input" placeholder="Min" v-model="minSqft">
          </div>
          <h6 class="d-inline middle-dash">-</h6>
          <div class="col left-dropdown-col">
            <input class="form-control sqft-input" placeholder="Max" v-model="maxSqft">
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p v-for="sqft in minSqfts" v-bind:key="sqft" class="no-margin sqft-select text-center" v-on:click="updateMinSqft(sqft)">{{ sqft.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
          </div>
          <div class="col">
            <p v-for="sqft in maxSqfts" v-bind:key="sqft" class="no-margin sqft-select text-center" v-on:click="updateMaxSqft(sqft)">{{ sqft.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
          </div>
        </div>
      </div>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      sqfts: [500, 750, 1000, 1250, 1500, 1750, 2000, 2250, 2500, 2750, 3000, 3250, 3500, 3750, 4000, 5000, 7000]
    }
  },
  methods: {
    ...mapMutations('homeSearch', [
      'updateMinSqft',
      'updateMaxSqft'
    ]),
    sqftHidden () {
      if (this.getMinSqft >= this.getMaxSqft) this.updateMaxSqft(null)
      if (this.getMinSqft > 7000) this.updateMinSqft(7000)
    }
  },
  computed: {
    ...mapGetters('homeSearch', [
      'getMinSqft',
      'getMaxSqft'
    ]),
    minSqft: {
      get () {
        return this.getMinSqft
      },
      set (value) {
        this.updateMinSqft(value)
      }
    },
    maxSqft: {
      get () {
        return this.getMaxSqft
      },
      set (value) {
        this.updateMaxSqft(value)
      }
    },
    minSqfts () {
      var index = this.sqfts.length
      if (this.getMaxSqft) {
        index = this.sqfts.findIndex((sqft) => {
          return sqft > this.getMaxSqft
        })
      }
      return this.sqfts.slice(0, index)
    },
    maxSqfts () {
      var index = 0
      if (this.getMinSqft) {
        index = this.sqfts.findIndex((sqft) => {
          return sqft > this.getMinSqft
        })
      }
      return this.sqfts.slice(index)
    }
  }
}
</script>

<style scoped>
.dropdown-form >>> .dropdown-item:hover {
  background-color: rgb(254, 237, 170) !important;
}

.dropdown-form >>> .btn {
  min-width: 160px;
  background-color: white !important;
  color: rgb(79, 79, 79);
  border-style: solid !important;
  border-color: gray !important;
  border-width: 1px !important;
  border-radius: 5px !important;
  padding-top: 7px !important;
  padding-bottom: 7px !important;
  margin-right: .3rem;
  margin-left: .3rem;
}

.dropdown-form >>> .dropdown-toggle::after {
  display:none;
}

.sqft-select:hover {
  background-color: rgb(254, 237, 170);
}

.sqft-select {
  border-radius: 30px;
  cursor: pointer;
}

.sqft-input {
  width: 100% !important;
}

.right-dropdown-col, .left-dropdown-col {
  padding: 0;
}

.middle-dash {
  padding-right: 5px;
  padding-left: 5px;
  padding-top: .5rem;
  margin-bottom: 0;
}

.dropdown-row {
  width: 250px;
}

.terms-text {
  text-decoration: underline;
  cursor: pointer;
}

.no-margin {
  margin: 0;
}

.color-button >>> .btn {
  background-color: #eaeaea !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeSearch/searchBar/buttons/Sqft.vue